import React from 'react';
import classNames from 'classnames';
import { IconSearch } from '@tabler/icons-react';
import './NSSearchInput.scss';
import { NSInput } from 'bricks';

export interface INSSearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    inputClassName?: string;
}

const NSSearchInput = ({
    value,
    onChange,
    className,
    inputClassName,
    placeholder = 'Search...',
}: INSSearchInputProps) => (
    <div className={classNames('NSSearchInput d-flex align-items-center gap-2 rounded shadow-lg', className)}>
        <IconSearch size={16} className="ml-2 mr-1 text-muted flex-shrink-0" />
        <NSInput
            name="search"
            type="text"
            aria-label={placeholder}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            placeholder={placeholder}
            customClassName={classNames('border-0 bg-transparent px-0 w-100 font-15', inputClassName)}
        />
    </div>
);

export default NSSearchInput;
